export const projects = ({ project }) => project.projects;
export const currentProject = ({ project: { currentProject: project } }) =>
  project;
export const user = ({ user: { user: currentUser } }) => currentUser;
export const pages = ({ web }) => web.pages;
export const currentPage = ({ web }) => web.currentPage;
export const currentPageVersion = ({ web }) => web.currentPageVersion;
